<template>
	<div class="tree">
		<a class="clickable text-muted" @click="getFilesRoot">
			<i id="root" class="mdi mdi-folder-open" style="color: rgb(3, 173, 217)"></i>
			{{ rootName }}
		</a>
		<ul class="list-unstyled text-muted ml-2">
			<li v-for="pasta in pastas" :key="pasta.id">
				<div>
					<a
						class="clickable text-muted"
						@click="
							getFiles(pasta);
							pastaSelected = pasta;
							clickFolderSub = false;
						"
					>
						<i
							class="mdi"
							:class="verifySelected(pasta.id) ? 'mdi-folder-open' : 'mdi-folder '"
							style="color: rgb(3, 173, 217)"
						></i>
						{{ pasta.nome }}
					</a>
					<arvore-subpasta
						v-show="verifySelected(pasta.id)"
						:subpastas="pasta.subpastas"
						:path-current="pathCurrent"
						@load="getFiles"
						@clicksub="clickFolderSub = true"
						:selected-pasta-box="selectedPastaBox"
					/>
				</div>
			</li>
		</ul>
	</div>
</template>
<script>
export default {
	props: [
		"pastasArvore",
		"rootName",
		"selectedPastaBox",
		"rootPasta",
		"pathCurrent",
	],
	data() {
		return {
			show_root: true,
			OpenRoot: true,
			pastas: [],
			subpastas: [],
			pastaSelected: "",
			clickFolderSub: false,
		};
	},
	watch: {
		pastasArvore(n, o) {
			this.pastas = this.pastasArvore;
		},
	},
	mounted() {
		this.pastas = this.pastasArvore;
	},
	methods: {
		verifySelected(id) {
			return this.pastaSelected.id == id ? true : false;
		},
		getFiles(pasta) {
			this.$emit("load", pasta);
		},
		getFilesRoot() {
			this.$emit("root", this.rootPasta);
		},
	},
};
</script>
<style lang="css">
.subpastas {
	display: none;
}
.clickable {
	cursor: pointer;
}
.show_folder {
	display: block;
}
ul ul a {
	background: #ffffff !important;
}
</style>
